import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div className="text-center">
      <p className="text-7xl md:text-8xl font-black text-gray-900 tracking-tight">404</p>
      <h1 className="mt-3 text-xl md:text-2xl font-semibold text-gray-800">Page not found</h1>
      <p className="mt-2 text-gray-500">This URL does not exist.</p>
      <Link
        to="/"
        className="inline-block mt-6 px-5 py-2.5 rounded-xl bg-purple-600 text-white text-sm font-semibold hover:bg-purple-700"
      >
        Go to Home
      </Link>
    </div>
  </div>
);

export default NotFoundPage;
